<template>
<div class="" style="padding-bottom: 90px;">
    <div class="bgp" style="text-align: center; text-shadow: 1px 1px 2px #333;">
        <h1 style="color: white; padding-top: 10px; padding-top: 170px;">Product Detail</h1>
        <p style="color: white; padding-top: 10px;">Home > RMS > POS > EuroDigiPos</p>
    </div>
    <div class="container" style="padding-top: 90px;">
        <div class="row">
            <div class="col-xl-6 col-md-6 col-sm-12" style="text-align: center; margin-bottom: 90px;">
                <b-img src="@/assets/RMS/pos1.jpg" fluid alt="Responsive image"></b-img>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12" >
                <h3>{{ $t('posServ1') }}</h3>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('posP1') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('posP2') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('posP3') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('posP4') }}
                </p>
            </div>
        </div>
        
       

        <h4 style="margin-top: 90px; margin-bottom: 40px;">{{ $t('speP36') }}</h4>
        <div class="row">
            <div class="col" style="">
                <b-img v-b-modal.modal-2 src="@/assets/RMS/epos1.jpg" fluid alt="Responsive image"></b-img>
            </div>
             <div class="col" style="">
                <b-img  @click="slide = 1" v-b-modal.modal-2 src="@/assets/RMS/epos2.jpg" fluid alt="Responsive image"></b-img>
            </div>
             <div class="col" style="">
                <b-img  @click="slide = 2" v-b-modal.modal-2 src="@/assets/RMS/epos3.jpg" fluid alt="Responsive image"></b-img>
            </div>
             <div class="col" style="">
                <b-img  @click="slide = 3" v-b-modal.modal-2 src="@/assets/RMS/epos4.jpg" fluid alt="Responsive image"></b-img>
            </div>
        </div>

        <b-modal id="modal-2" size="xl" style="" hide-footer hide-header>
            <div>
                <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="3000"
                controls
                background="#ababab"
                img-width="1024"
                img-height="480"
                style="text-shadow: 1px 1px 2px #333;"
                >
                    <b-carousel-slide img-src="@/assets/RMS/epos1.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="@/assets/RMS/epos2.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="@/assets/RMS/epos3.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="@/assets/RMS/epos4.jpg"></b-carousel-slide>
                </b-carousel>
            </div>
        </b-modal>

    </div>
</div> 
</template>

<script>

export default {
  name: 'EuroDigiPos',
  data(){
      return{
       slide: 0,
        }
  },
  async mounted(){
  },

  methods : {
      
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.bgp{
background-image: url("../../assets/att.jpg");
background-size: cover;
height: 400px;
}
.center {
margin-left: 45%;
padding-top: 200px;
color: white;
}
.underline {
  color: black;
  display: inline-block;
  font-size: 0.875rem;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.underline:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}



</style>
